
import dynamicDataLoader from './dynamicDataLoader';
import liveDataLoader from './liveDataLoader';
import offlineDataLoader from './offlineDataLoader';

import ResponseSendingQueue from '../services/ResponseSendingQueue';
import sessionReader from '../store/readHelpers/SessionReader';
import ResourceInitializer from './resources/resourceInitializer';

let mockDataLoader;
if (process.env.NODE_ENV === 'unit-testing' || process.env.NODE_ENV === 'development') {
    if (window.location.href.indexOf('bypassMockDataLoader=true') === -1) {
        mockDataLoader = require('./mockDataLoader').default;
    }
}

const dataLoader = {
    async initDataLoading() {
        if (window.offlineMode) {
            return offlineDataLoader.loadInitialData();
        }

        if (mockDataLoader) {
            return mockDataLoader.loadInitialData();
        }

        try {
            await ResourceInitializer.initBaseResources();
        } catch (error) {
            console.error(error);
        }

        if (sessionReader.useDynamicLoading()) {
            dynamicDataLoader.init();
            if (sessionReader.getContext() !== undefined) {
                return liveDataLoader.loadInitialData();
            }
        } else {
            await liveDataLoader.loadInitialData();
            ResponseSendingQueue.getInstance().startQueue();
        }

        return undefined;
    },
};

export default dataLoader;
